<template>
  <div id="My_Info_Photo_main" :class="['container ub ub-ver', { 'container-dark': theme_dark }]">
    <div class="nav-top fix">
      <div class="nav-left" @click="back()">
        <img src="../../assets/img/返回箭头.png" class="nav-img" />
        <span class="nav-lable"></span>
      </div>
      <div class="nav-middle">小火柴挣钱攻略</div>
      <div class="nav-right">
        <span class="nav-lable"></span>
        <img src="../../assets/img/更换.png" class="nav-img none" />
      </div>
    </div>

    <div style="height: 2.6rem;"></div>
    
    <div class="strategy-top">
      小火柴邀你瓜分
      <span class="ft-col">6亿&nbsp;</span>聊天补贴
    </div>

    <div class="strategy-middle">
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;终于等到你，亲爱的用户，小火柴目前已经对外开放了特权用户功能，经过平台
      <span class>认证审核</span>的用户，在小火柴平台聊天即可获得
      <span class>聊天补贴</span>，可在个人中心进行提现。
    </div>

    <div class="line"></div>

    <div>
      <div class="item">
        <div class="ub ub-pc">
          <div class="tag"></div>
          <p class="question">介绍</p>
        </div>
        <div class="answer">
          <span class>挣钱 = 挣积分</span>，平台采用积分制，积分通过简单的兑换规则即可进行提现。
          努力获取到积分，就是在挣钱！根据平台当前的数据来看，一天轻轻松松赚取100元~300元。
        </div>
      </div>


      <div class="line"></div>

      <div class="item">
        <div class="ub ub-pc">
          <div class="tag"></div>
          <p class="question">如何挣钱</p>
        </div>
        <div class="answer">
          <p class="answer-item">
            挣钱需要获取积分，获取积分的方式有如下几种：
          </p>

          <div class="answer-item mg-top mkmny">
            <p class="mkmny-type">方式1:聊天收入</p>
            <p>
              在聊天过程中，用户只要及时的回复消息就可以获得聊天收入！一直回复，一直得积分！回复越及时，奖励越高。
            </p>
            <div class="ub ub-ac ub-pc">
              <img src="../../assets/img/new2024/chat-score.png" style="width:50%;" />
            </div>
            <p>
              可以在“赚积分”里设置聊天收费，其他用户与自己聊天时需要支付金币（默认为免费），相应的可获得聊天积分。
            </p>
            <div class="ub ub-ac ub-pc">
              <img src="../../assets/img/new2024/private-letter.png" style="width:50%;" />
            </div>
            <p>
              特别说明：当前阶段只针对部分女生用户开放了这项功能，后续会考虑扩大用户范围
            </p>
          </div>

          <div class="answer-item mg-top mkmny">
            <p class="mkmny-type">方式2: 每日任务（赚积分）</p>
            <p>
              小火柴为用户提供了免费赚积分的方式，包括每日登录，打招呼奖励，回复私信奖励，礼物奖励，在线奖励等。
            </p>
            <p style="font-weight: bold;">每日登录</p>
            <p>
              每日登录小火柴系统，即可获得50积分。
            </p>

            <p style="font-weight: bold;">打招呼奖励</p>
            <p>
              在登录小火柴后，向用户发送10次打招呼的消息即可获得100积分。
            </p>

            <p style="font-weight: bold;">回复奖励</p>
            <p>
              在消息页面向其他用户完成10次消息回复即可获得100的奖励积分。
            </p>

            <p style="font-weight: bold;">礼物奖励</p>
            <p>
              每日收到任何礼物，即可获得100-5000的奖励积分。
            </p>

            <p style="font-weight: bold;">在线奖励</p>
            <p>
              在小火柴保持在线状态，并能够与其他用户进行匹配聊天即可获得100-9000的积分奖励。
              在线时间越长，奖励就会越高~
            </p>

            <p style="font-weight: bold;">分享奖励（敬请期待）</p>
            <p>
              将系统生成的链接分享给微信好友、朋友圈、群聊，即可获得平台一定的积分奖励。
            </p>
          </div>

          <div class="answer-item mg-top mkmny">
            <p class="mkmny-type">方式3: 加好友</p>
            <p>
              聊天过程中，收到对方添加为好友申请，同意即可获得 300 积分。
            </p>
            <div class="ub ub-ac ub-pc">
              <img src="../../assets/img/加好友截图-1.png" style="width:50%;" />
            </div>
          </div>

          <div class="answer-item mg-top mkmny">
            <p class="mkmny-type">方式4: 收到礼物</p>
            <p>
              聊天过程中，收到对方送来的礼物，即可获得 100到 10万不等的积分。收到礼物截图如下：
              （不同礼物的积分规则）
            </p>
            <div class="ub ub-ac ub-pc">
              <img src="../../assets/img/收礼物.png" style="width:50%;" />
            </div>

            <p>
              礼物的积分规则如下：
            </p>
            <div class="line"></div>
            <div class="ub rules">
              <div>礼物</div>
              <div>名称</div>
              <div>积分</div>
            </div>

            <li v-for="(item, index) in ary_gift" :key="index">
              <div class="line"></div>
              <div class="ub ub-pc rules">
                <img :src="item.url"/>
                <div>{{item.name}}</div>
                <div>{{item.score}}&nbsp;</div>
              </div>
            </li>

          </div>

          <div class="answer-item mg-top mkmny">
            <p class="mkmny-type">方式5: 其他获取积分方式</p>
            <p>
              敬请期待~
            </p>
          </div>

        </div>
      </div>

      
      <div class="line"></div>

      <div class="item">
        <div class="ub ub-pc">
          <div class="tag"></div>
          <p class="question">获取资格</p>
        </div>
        <div class="answer">
          <p class="answer-item">
            经平台认证过的用户即可拥有赚钱资格，流程如下:
          </p>
          <div>
            <ul class="ub photo">
              <li class="ub ub-ac ub-pc ub-f1">
                <img src="../../assets/img/手机认证.png" class="rz-photo" />
              </li>
              <li class="ub ub-ac ub-pc two">
                <img src="../../assets/img/认证箭头.png" class="rz-arrow" />
              </li>
              <li class="ub ub-ac ub-pc ub-f1">
                <img src="../../assets/img/微信认证.png" class="rz-photo" />
              </li>
              <li class="ub ub-ac ub-pc four">
                <img src="../../assets/img/认证箭头.png" class="rz-arrow" />
              </li>
              <li class="ub ub-ac ub-pc ub-f1">
                <img src="../../assets/img/性别认证.png" class="rz-photo" />
              </li>
            </ul>

            <ul class="ub txt">
              <li class="ub ub-ac ub-pc ub-f1">手机认证</li>
              <li class="ub ub-ac ub-pc two"></li>
              <li class="ub ub-ac ub-pc ub-f1">微信认证</li>
              <li class="ub ub-ac ub-pc four"></li>
              <li class="ub ub-ac ub-pc ub-f1">性别认证</li>
            </ul>

          </div>

          <div class="ub ub-ac" @click="goto_renzhen()">
            <div class="ub ub-ac ub-pc rz-btn">马上认证--></div>
          </div>
        </div>
      </div>

      <div class="line"></div>

      <div class="item">
        <div class="ub ub-pc">
          <div class="tag"></div>
          <p class="question">如何提现</p>
        </div>
        <div class="answer">
          积分可以直接提现,在
          <span class="ft-col">我的 --> 我的钱包 --> 立即提现</span>
        </div>
      </div>

      <div class="line"></div>

      <div class="item">
        <div class="ub ub-pc">
          <div class="tag"></div>
          <p class="question">违规说明</p>
        </div>
        <div class="answer">
           请广大用户遵守平台规则，平台当前还处于为用户提供补贴阶段，对有但不限于如下情况者将进行严惩：<br/>
           (1) 涉嫌性别欺诈行为（男扮女进行骗取礼物，或者女扮男进行骗取礼物）<br/>
           (2) 盗取他人照片随意散播的行为 <br/>
           (3) 恶意刷榜行为（包括魅力榜和豪气榜） <br/>
           (4) 自己给自己大量送礼物的行为 <br/>
           (5) 引流广告行为(通过留扣扣微信等联系方式，将平台用户引走的行为) <br/>
           (6) 聊天低俗恶俗涉黄，被多次投诉的行为 <br/>

           <br/>
           具体惩罚办法试具体情节而定。违规及处罚最终解释权归小火柴平台所有。

        </div>
      </div>

    </div>
  </div>
</template>

<script>
import * as tool from "../../api/common";
  export default {
    data() {
      return {
        ary_gift: [],
        theme_dark: false
      };
    },
    mounted() {
      //切换深色模式
      this.theme_dark = tool.is_theme_dark(this);
      this.init_page();
    },
    methods: {
      back() {
        this.$router.go(-1); //返回上一层
      },
      goto_renzhen() {
        this.$router.push({ name: 'rz' })
      },
      init_page(){
        var const_data = this.$store.state.const_data;
        this.ary_gift = const_data.gift_1.concat(const_data.gift_2);
      }
    }
  };
</script>

<style lang="scss" scoped>
.nav-top {
  background-color: #8A61FF;
}
.container {
    background-color: #fff;
    .line {
      border-top: 1px solid #dcdcdc;
      margin: 0.3rem 0;
    }
}
.fix{
    position: fixed;
    width: 100%;
}
  

  .strategy-top {
    height: 5rem;
    text-align: center;
    line-height: 5rem;
    font-size: 1.5rem;
    background-color: #8A61FF;
    background-image: linear-gradient(to bottom, #8A61FF, #FE9CC0);
    font-weight: 600;
    color: #fff;
    .ft-col {
      color: #8A61FF;
    }
  }

  .strategy-middle {
    padding: 0.5rem;
    line-height: 2rem;
    font-size: 0.8rem;
    color: #565656;
  }

  .item {
    padding: 0.5rem;
    .tag {
      width: 0.2rem;
      height: 0.9rem;
      background-color: #e92162;
      margin-right: 0.2rem;
    }
    .question {
      margin: 0;
      color: #000;
      font-weight: 600;
    }
    .answer {
      font-size: 0.8rem;
      color: #565656;
      line-height: 1.6rem;
      margin: 0.8rem 0.7rem;
      .answer-double {
        margin-bottom: 1rem;
      }
    }
    .rules {
      justify-content: space-around;
      img {
        width:3rem;
        height:3rem;
      }
    }
  }
  
  .mg-top {
    margin-top: 0.5rem;
  }

  .mkmny {
    border: dotted 1px #e92162;
    padding: 0 0.5rem;
    border-radius: 0.3rem;
    .mkmny-type {
      font-weight: bold;
      color: #e92162;
    }
  }

  .mkmny-no {
    border: dotted 1px #e92162;
    padding: 0 0.5rem;
    border-radius: 0.3rem;
    .mkmny-type {
      font-weight: bold;
      color: #666;
    }
  }

  .rz-btn {
    color: #e92162;
    margin-top: 0.5rem;
  }

  .photo {
    justify-content: space-between;
    height: 5rem;
    .rz-photo {
      width: 3.5rem;
      height: 3.5rem;
    }
    .rz-arrow {
      width: 3rem;
      height: 3rem;
    }
  }

  .txt {
    justify-content: space-between;
    height: 3rem;
    .two {
      width: 3rem;
    }
    .four {
      width: 3rem;
    }
  }

  .container-dark {
    background-color: #2F2E33;
    .strategy-middle {
      color: #FDFDFD;
    }
    .item {
      .question {
        color: #FDFDFD;
      }
      .answer {
        color: #888;
      }
      
    }
    .line {
      border-top: 1px solid #404040;
    }
  }
</style>